import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "vue-content-placeholders-heading" }
const _hoisted_2 = {
  key: 0,
  class: "vue-content-placeholders-heading__img"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "vue-content-placeholders-heading__content" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "vue-content-placeholders-heading__title" }),
  /*#__PURE__*/_createElementVNode("div", { class: "vue-content-placeholders-heading__subtitle" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.img)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
      : _createCommentVNode("", true),
    _hoisted_3
  ]))
}